import {FanNumberSequence, MultiFanCoordinates} from "./multiFanNoise";
import {CoolerFan} from "./CoolerFan";
import {RequiredVisibilityRect} from "./RequiredVisibilityRect";

/**
 * Chłodnica - zawiera wiele wentylatorów
 */
export class Cooler {
    private fans: CoolerFan[] = [];

    constructor(
        readonly centerCoordinates: MultiFanCoordinates,
        readonly widthMeters: number,
        readonly heightMeters: number,
        readonly fanCaseDiameterMeters: number,
        readonly fanColumnCountInCooler: number,
        readonly fanRowCountInCooler: number,
        readonly pwlDba: number,
        readonly coolerZCoordinate: number,
        private fanNumberSequence: FanNumberSequence
    ) {
    }

    /**
     * Rozmieszcza wentylatory równomiernie na szerokości i wysokości chłodnicy
     */
    createFans(): void {
        this.fans = [];
        const startX = this.centerCoordinates.xMeters - this.widthMeters / 2;
        const startY = this.centerCoordinates.yMeters - this.heightMeters / 2;

        for (let row = 0; row < this.fanRowCountInCooler; row++) {
            for (let col = 0; col < this.fanColumnCountInCooler; col++) {
                // Rozmieszczenie równomierne
                const x = startX + (col + 0.5) * (this.widthMeters / this.fanColumnCountInCooler);
                const y = startY + (row + 0.5) * (this.heightMeters / this.fanRowCountInCooler);

                const fan = new CoolerFan(
                    new MultiFanCoordinates(x, y, this.coolerZCoordinate),
                    this.fanCaseDiameterMeters,
                    this.pwlDba,
                    this.fanNumberSequence.getNextNumber(),
                    this.coolerZCoordinate
                );
                this.fans.push(fan);
            }
        }
    }

    getFans(): CoolerFan[] {
        return this.fans;
    }

    getRequiredVisibilityRect(): RequiredVisibilityRect {
        const halfWidth = this.widthMeters / 2;
        const halfHeight = this.heightMeters / 2;
        return new RequiredVisibilityRect(
            this.centerCoordinates.xMeters - halfWidth,
            this.centerCoordinates.yMeters - halfHeight,
            this.centerCoordinates.xMeters + halfWidth,
            this.centerCoordinates.yMeters + halfHeight
        );
    }

    renderToSVG(svgScale: number): string {
        const halfWidth = this.widthMeters / 2;
        const halfHeight = this.heightMeters / 2;
        const scaledX = (this.centerCoordinates.xMeters - halfWidth) * svgScale;
        const scaledY = (this.centerCoordinates.yMeters - halfHeight) * svgScale;
        const scaledWidth = this.widthMeters * svgScale;
        const scaledHeight = this.heightMeters * svgScale;
        const strokeWidth = Math.max(0.08 * svgScale, 0.15); // Grubość obrysu chłodnicy

        const fansHtml = this.fans.map(fan => fan.renderToSVG(svgScale)).join('');

        return `
            <g>
                <rect x="${scaledX}" y="${scaledY}" width="${scaledWidth}" height="${scaledHeight}" fill="none" stroke="#333333" stroke-width="${strokeWidth}" stroke-dasharray="8,4" />
                ${fansHtml}
            </g>
        `;
    }
}